// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "335px";
var _3 = "112px";
var _4 = "card-3xIpd";
var _5 = "card_withoutPanorama-2CTw8";
var _6 = "card__focusHighlight-LeJ9m";
var _7 = "card__panorama-FFIM2";
var _8 = "card__weather-1ToRD";
var _9 = "card__content-3cvaP";
var _a = "card__weatherIcon-3VRBe";
var _b = "card__temperature-3VV68";
var _c = "card__airportName-KEwGf";
var _d = "card__airportName_withIATA-2Dm0R";
var _e = "card__airportIATA-1ycS_";
var _f = "card__airportLink-c2NLX";
var _10 = "card__chevronIcon-1DdSZ";
export { _1 as "__esModule", _2 as "width", _3 as "height", _4 as "card", _5 as "card_withoutPanorama", _6 as "card__focusHighlight", _7 as "card__panorama", _8 as "card__weather", _9 as "card__content", _a as "card__weatherIcon", _b as "card__temperature", _c as "card__airportName", _d as "card__airportName_withIATA", _e as "card__airportIATA", _f as "card__airportLink", _10 as "card__chevronIcon" }
export default { "__esModule": _1, "width": _2, "height": _3, "card": _4, "card_withoutPanorama": _5, "card__focusHighlight": _6, "card__panorama": _7, "card__weather": _8, "card__content": _9, "card__weatherIcon": _a, "card__temperature": _b, "card__airportName": _c, "card__airportName_withIATA": _d, "card__airportIATA": _e, "card__airportLink": _f, "card__chevronIcon": _10 }
